import { CommonModule } from '@angular/common';
import { Component, effect, input, signal } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
  selector: 'empathy-min-view-time-setting',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSlideToggle],
  templateUrl: './min-view-time-setting.component.html',
  styleUrls: ['./min-view-time-setting.component.scss', './_min-view-time-setting-theme.component.scss']
})
export class MinViewTimeSettingComponent {
  activeQuestion = input<FormGroup>();
  showBorder = input(true);

  minViewTimeEnabled$ = signal(false);

  constructor() {
    effect(
      () => {
        const form = this.activeQuestion();
        if (!form) {
          return;
        }

        const minViewCtrl = form.get('minViewTimeSeconds');
        if (minViewCtrl) {
          this.minViewTimeEnabled$.set((Number(minViewCtrl.value) || 0) > 0);
        }
      },
      { allowSignalWrites: true }
    );
  }

  private get minViewTimeCtrl(): AbstractControl | null {
    return this.activeQuestion()?.get('minViewTimeSeconds') ?? null;
  }

  onMinViewTimeToggleChange(enabled: boolean): void {
    this.minViewTimeEnabled$.set(enabled);

    if (!enabled) {
      this.minViewTimeCtrl?.setValue(0);
    } else if (this.minViewTimeCtrl?.value <= 0) {
      this.minViewTimeCtrl?.setValue(1);
    }
  }

  onMinViewTimeBlur(): void {
    if (this.minViewTimeEnabled$() && this.minViewTimeCtrl?.value < 1) {
      this.minViewTimeCtrl.setValue(1);
    }
  }
}
